var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../styleConstants';
export var LOADER_SIZE = {
    small: 14,
    medium: 18,
    large: 22,
    extraLarge: 48,
};
var spin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"], ["\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n"])));
var LoaderWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: 3px solid ", ";\n  border-top: 3px solid ", ";\n  border-radius: 50%;\n  animation: ", " 1.5s linear infinite;\n"], ["\n  display: inline-block;\n  width: ", "px;\n  height: ", "px;\n  border: 3px solid ", ";\n  border-top: 3px solid ", ";\n  border-radius: 50%;\n  animation: ", " 1.5s linear infinite;\n"])), function (props) { return props.size || 16; }, function (props) { return props.size || 16; }, colors.primaryGreyLight, colors.primaryGreyDark, spin);
var Loader = function (_a) {
    var size = _a.size;
    var loaderSize = useMemo(function () { return LOADER_SIZE[size !== null && size !== void 0 ? size : 'medium']; }, [size]);
    return React.createElement(LoaderWrapper, { size: loaderSize });
};
export default Loader;
var templateObject_1, templateObject_2;
